import * as angular from 'angular';

(function () {
    'use strict';

    angular.module('app').controller('SetEmailController', SetEmailController);

    /** @ngInject */
    function SetEmailController(
        $scope,
        $state,
        AuthFactory,
        TenantFactory,
        toastr
    ) {
        var vm = this,
            phone;

        TenantFactory.read().then(function (response) {
            phone = response.data.phone;
        });

        vm.sendDataToBackend = function () {
            var data = {
                email: vm.email,
                phone: phone,
            };

            TenantFactory.setEmail(data)
                .success(function () {
                    toastr.success(
                        'Potwierdź swój adres e-mail, aby móc się zalogować.'
                    );
                    AuthFactory.logout();
                    $state.go('login');
                })
                .error(function (response) {
                    for (var key in response) {
                        var value = response[key];

                        if ($scope.loginForm && key != 'non_field_errors') {
                            $scope.loginForm[key].$setValidity(
                                'error_field',
                                true
                            );
                        }

                        value.forEach(function (element, index, array) {
                            toastr.error(value[index]);
                        });
                    }
                });
        };
    }
})();



// WEBPACK FOOTER //
// ./node_modules/angularjs-template-loader??ref--0-1!./src/app/components/auth/set_email/set_email.controller.ts